import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/BlogList/BlogList.js
const BlogList = createSectionForm({
  icon: "list-check",
  title: "Blog List",
  fields: [{ name: "empty_text", label: "Empty Text", placeholder: "No Blog Found" }],
});

export default BlogList;
